import { atom } from 'nanostores';

export interface LocalCommand {
  id: string;
  label: string;
  description?: string;
  icon?: string;
  keywords?: string[];
  onSelect: () => void | Promise<void>;
}

// Store: Map<providerId, LocalCommand[]>
export const localCommandsAtom = atom<Map<string, LocalCommand[]>>(new Map());

export function register(providerId: string, commands: LocalCommand[]): () => void {
  const current = new Map(localCommandsAtom.get());
  current.set(providerId, commands);
  localCommandsAtom.set(current);

  return () => unregister(providerId);
}

export function unregister(providerId: string): void {
  const current = new Map(localCommandsAtom.get());
  current.delete(providerId);
  localCommandsAtom.set(current);
}

// Expose to window (follows sidebar pattern)
Object.assign(window, {
  __hydra_commands__: {
    register,
    unregister,
  } satisfies Window['__hydra_commands__'],
});
